import { store } from "../redux/store";
import { DEFAULT_ONLINE_ORDER_VOLUME } from "../redux/reducers/settings/sounds";

import { createOnlineOrderTracker, TrackedOrder } from "./onlineOrderTracker";
import { playOnlineOrderSound } from "./notificationSound";

/**
 * Склейка: список заказов подписки «все» → трекер новизны → звук, если
 * включено в настройках заказа. Трекер работает всегда (и при выключенной
 * опции), чтобы включение опции не озвучивало уже висящие заказы.
 */

const tracker = createOnlineOrderTracker();

export function notifyNewOnlineOrders(models: TrackedOrder[]) {
	const freshIds = tracker.track(models);
	if (!freshIds.length) return;

	const settings = (store.getState() as any)?.settings?.order?.general
		?.notifyOnlineOrders;
	if (!settings?.active) return;

	playOnlineOrderSound(
		settings.sound ?? null,
		settings.volume ?? DEFAULT_ONLINE_ORDER_VOLUME,
	).catch(() => undefined);
}

export { tracker as onlineOrderTracker };
